import data from './countries.json'

export interface Country {
  name: string
  code: string // ISO 3166-1 alpha-2, e.g. "EC"
  phone_code: string // dial code, e.g. "+593"
}

export const COUNTRIES = data as Country[]

const BY_CODE = new Map(COUNTRIES.map((country) => [country.code, country]))
const BY_NAME = new Map(
  COUNTRIES.map((country) => [country.name.toLowerCase(), country]),
)

// Defaults for a school in Ecuador.
export const DEFAULT_COUNTRY_CODE = 'EC'
export const DEFAULT_COUNTRY_NAME = 'Ecuador'

export function countryByCode(code: string | null | undefined): Country | undefined {
  return code ? BY_CODE.get(code) : undefined
}

export function countryByName(name: string | null | undefined): Country | undefined {
  return name ? BY_NAME.get(name.toLowerCase()) : undefined
}

// "EC" → "+593"
export function dialCode(code: string | null | undefined): string | null {
  return countryByCode(code)?.phone_code ?? null
}
